export enum FaqTarget {
  MANAGER = 'MANAGER',
  AFFILIATE = 'AFFILIATE',
  CUSTOMER = 'CUSTOMER',
}
